import { graphql } from "react-relay";

export const SetPolicyDisabledMutation = graphql`
  mutation SetPolicyDisabledMutation($input: SetPolicyDisabledInput!) {
    setPolicyDisabled(input: $input) {
      policy {
        disabled
        disabledAudit {
          what
          when
          who {
            displayName
            email
          }
          why
        }
        id
        uuid
        # Policy.disabled is shared by every version of the policy, but each
        # version is a distinct Relay record; the updater uses these ids to
        # patch every cached version in the store, not just the one returned
        # above (see SetPolicyDisabledDialog). first: 1000 as a stand-in for
        # "all versions" — same convention used elsewhere in this codebase
        # for connections with no true unbounded fetch (e.g. RepositoryPicker).
        versions(first: 1000) {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
`;
